import { useEffect, useState } from 'react';

const fallbackFaqs = [
  {
    slug: 'por-que-elegir-adt',
    title: '¿Por qué elegir ADT?',
    metaDesc:
      'ADT ofrece monitoreo 24 horas, soporte especializado y tecnología avanzada para proteger hogares y comercios.',
    faqItems: [
      {
        title: '¿Por qué elegir ADT?',
        contentMd: 'ADT ofrece monitoreo 24 horas, soporte especializado y tecnología avanzada para proteger hogares y comercios.',
        contentHtml: '<p>ADT ofrece monitoreo 24 horas, soporte especializado y tecnología avanzada para proteger hogares y comercios.</p>',
      },
    ],
  },
  {
    slug: 'como-cotizar-tu-alarma-adt',
    title: '¿Cómo cotizo mi alarma ADT?',
    metaDesc:
      'Completás tus datos, recibís una cotización personalizada y luego coordinamos la instalación del sistema.',
    faqItems: [
      {
        title: '¿Cómo cotizo mi alarma ADT?',
        contentMd: 'Completás tus datos, recibís una cotización personalizada y luego coordinamos la instalación del sistema.',
        contentHtml: '<p>Completás tus datos, recibís una cotización personalizada y luego coordinamos la instalación del sistema.</p>',
      },
    ],
  },
  {
    slug: 'que-incluye-un-pack-de-seguridad-adt',
    title: '¿Qué incluye un pack de seguridad ADT?',
    metaDesc:
      'Puede incluir panel de control, sensores de movimiento, contactos magnéticos, cámara HD y acceso desde la app ADT.',
    faqItems: [
      {
        title: '¿Qué incluye un pack de seguridad ADT?',
        contentMd: 'Puede incluir panel de control, sensores de movimiento, contactos magnéticos, cámara HD y acceso desde la app ADT.',
        contentHtml: '<p>Puede incluir panel de control, sensores de movimiento, contactos magnéticos, cámara HD y acceso desde la app ADT.</p>',
      },
    ],
  },
];

const buildDefaultFaqsApiUrl = () => {
  if (typeof window === 'undefined') {
    return 'http://localhost:3000/api/faqs';
  }

  if (window.location.hostname === 'alarmitastaging.netlify.app') {
    return 'https://admin.alarmita.com/api/faqs';
  }

  if (window.location.hostname === 'alarmita.com' || window.location.hostname === 'www.alarmita.com') {
    return 'https://admin.alarmita.com/api/faqs';
  }

  if (process.env.NODE_ENV === 'production') {
    return 'https://admin.alarmita.com/api/faqs';
  }

  const adminPort = window.location.port === '3000' ? '3002' : '3000';
  return `${window.location.protocol}//${window.location.hostname}:${adminPort}/api/faqs`;
};

export default function usePublishedFaqs() {
  const [items, setItems] = useState(fallbackFaqs);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    const shouldUseAdminApi =
      hostname === 'alarmitastaging.netlify.app' ||
      hostname === 'alarmita.com' ||
      hostname === 'www.alarmita.com';
    const url = shouldUseAdminApi ? 'https://admin.alarmita.com/api/faqs' : process.env.REACT_APP_FAQS_API_URL || buildDefaultFaqsApiUrl();

    fetch(url, { cache: 'no-store' })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (data?.items?.length) {
          setItems(data.items);
        } else {
          setItems(fallbackFaqs);
        }
      })
      .catch(() => {
        setItems(fallbackFaqs);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return {
    items,
    loading,
  };
}
